import { ReactComponent as ArrowRight } from "../Assets/Icons/arrow-narrow-right.svg";
import { ReactComponent as Trash } from "../Assets/Icons/trash.svg";
import { ReactComponent as CreditCard } from "../Assets/Icons/credit-card-blue.svg";
import { ReactComponent as ChevronUp } from "../Assets/Icons/chevron-up.svg";
import { ReactComponent as ChevronDown } from "../Assets/Icons/chevron-down.svg";
import { ReactComponent as CirclePlus } from "../Assets/Icons/circle-plus.svg";
import { ReactComponent as CircleCheck } from "../Assets/Icons/circle-check.svg";
import { ReactComponent as UserX } from "../Assets/Icons/user-x.svg";
import { ReactComponent as CircleX } from "../Assets/Icons/circle-x.svg";
import { ReactComponent as Write } from "../Assets/Icons/writing-sign.svg";
import { ReactComponent as Note } from "../Assets/Icons/notes.svg";
import { ReactComponent as GtmFlag } from "../Assets/Icons/gtmFlag.svg";
import { ReactComponent as Lightning } from "../Assets/Icons/lightning.svg";
import { ReactComponent as User } from "../Assets/Icons/user-blue.svg";
import { ReactComponent as Bank } from "../Assets/Icons/bank.svg";
import { ReactComponent as ArrowDownCirle } from "../Assets/Icons/arrow-down-circle.svg";
import { ReactComponent as CircleSelected } from "../Assets/Icons/circle-selected.svg";
import { ReactComponent as AlertTriangle } from "../Assets/Icons/alert-triangle.svg";
import { ReactComponent as Upload } from "../Assets/Icons/upload.svg";
import { ReactComponent as InfoCircle } from "../Assets/Icons/info-circle.svg";

// eslint-disable-next-line
export const iconTypes: any = {
  arrowRight: ArrowRight,
  trash: Trash,
  creditCard: CreditCard,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  circlePlus: CirclePlus,
  circleCheck: CircleCheck,
  userX: UserX,
  circleX: CircleX,
  gtmFlag: GtmFlag,
  note: Note,
  write: Write,
  lightning: Lightning,
  user: User,
  bank: Bank,
  arrowDownCirle: ArrowDownCirle,
  circleSelected: CircleSelected,
  alertTriangle: AlertTriangle,
  upload: Upload,
  infoCircle: InfoCircle,
};

export const handleSize = (size: string) => {
  switch (size) {
    case "small":
      return "16px";
    case "medium":
      return "24px";
    case "large":
      return "32px";
    case "xlarge":
      return "40px";
    case "xxlarge":
      return "75px";
    case "xxxlarge":
      return "125px";
    default:
      return "18px";
  }
};

export const handleColor = (color: string) => {
  switch (color) {
    case "white":
      return (props: { theme: { White: string } }) => props.theme.White;
    case "black":
      return (props: { theme: { Black: string } }) => props.theme.Black;
    case "blue":
      return (props: { theme: { Dark_Cornflower_Blue: string } }) =>
        props.theme.Dark_Cornflower_Blue;
    case "Eerie_Black":
      return (props: { theme: { Eerie_Black: string } }) =>
        props.theme.Eerie_Black;
    case "Dark_Silver":
      return (props: { theme: { Dark_Silver: string } }) =>
        props.theme.Dark_Silver;
    case "Madder_Lake":
      return (props: { theme: { Madder_Lake: string } }) =>
        props.theme.Madder_Lake;
    case "Dark_Cornflower_Blue":
      return (props: { theme: { Dark_Cornflower_Blue: string } }) =>
        props.theme.Dark_Cornflower_Blue;
    case "Primary_600":
      return (props: { theme: { Primary_600: string } }) =>
        props.theme.Primary_600;
    case "Gradients_01":
      return (props: { theme: { Gradients_01: string } }) =>
        props.theme.Gradients_01;
    case "Amaranth_Red":
      return (props: { theme: { Amaranth_Red: string } }) =>
        props.theme.Amaranth_Red;
  }
};
